module.exports = __webpack_public_path__ + "static/media/noun_Einstein_16422.92c9ee2c.svg";